// Tiny dev-only logger so we never ship console noise to production users
// while still surfacing errors to developers during local work.
const isDev = process.env.NODE_ENV !== "production";

export const logWarn = (...args) => {
  if (isDev) console.warn(...args);
};

export const logError = (...args) => {
  if (isDev) console.error(...args);
};
